export default __webpack_public_path__ + "static/media/darkPurpleTerraform.83137888.svg";